<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="containerFillForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                containerFillForm: () => import('../forms/ContainerFillForm'),
                headers: [
                    { text: 'Harvesting', value: 'harvestingId', table: 'harvestings', form: () => import('../forms/HarvestingForm') },
                    { text: 'Container', value: 'containerId', table: 'containers', form: () => import('../forms/ContainerForm') },
                    { text: 'Fill Percentage', value: 'fillPercentage' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    containers: [],
                    harvestings: [],
                    items: []
                },
                sorting: [
                    { column: "harvestingId", direction: "ascending" },
                    { column: "containerId", direction: "ascending" },
                ],
                itemsField: 'containerFills',
                editPageName: 'containerFill',
                apiMethod: 'ContainerFills',
                claimName: 'ContainerFills',
                formTitle: 'Container Fill',
                excelTitle: 'Container Fills',
                hasEditPage: false,
            }
        },
    };
</script>
